import { Icon } from "@iconify/react";
import FrontText from "../FrontText";

const FrontExpandButton = ({ children, expanded = false, ...props }) => {
    const styles = `rounded-4 border border-light-blue text-light-blue flex gap-x-c10 py-c9 flex items-center px-c30 hover:bg-light-blue hover:text-white transition-all ease-in-out duration-300`;

    return (
        <button type="button" {...props} className={styles}>
            <FrontText textSize="16/20">{children}</FrontText>
            <Icon icon={`mingcute:${expanded ? 'up' : 'down'}-fill`} width={24} height={24} />
        </button>
    );
};

export default FrontExpandButton;
